export enum dndItemTypes {
    TASK = 'task',
    GOAL = 'goal',
    SET = 'set'
}